"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authChannel = void 0;
const sync_1 = require("@food/sync");
const authChannel = new sync_1.Channel('@food/auth');
exports.authChannel = authChannel;
//# sourceMappingURL=channels.js.map